import './accountpage.scss'
import React, { useEffect, useState } from "react";
import NoImage from "Ecommerce/template_three/assets/images/Noimage.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { _Api, _Apiauth } from 'Ecommerce/common/api';

import EditIcon from 'Ecommerce/template_three/assets/icons/EditIcon';
import Sidebar from './Sidebar';
import billingandShippingCardImage from 'Ecommerce/common/images/billingandshipping.png'
import AppointmentCardImage from 'Ecommerce/common/images/appointmentcardimg.png'
import ChangePasswordCardImage from 'Ecommerce/common/images/changepwdcardimg.png'
import PurchaseHistoryCardImage from 'Ecommerce/common/images/purchasehistorycardimg.png'
import './accountpage.scss'
import LeftIcon from 'admin/common/icons/sidebar/LeftIcon';
import useScreenSize from 'Ecommerce/template_three/include/Common/useScreenSize';

export default function AccountIndexPage() {
    const { t } = useTranslation();
    const screenSize = useScreenSize();
    const navigate = useNavigate();
    const [accountdata, setAccountdata] = useState({
        contacts: [{ icon: 1, phoneCode: "", number: "" }],
    });


    const getaccountdetails = async () => {
        try {
            let postdata = {};
            let res = await _Api(postdata, `account/getDetails`);
            if (res?.statusCode === 200) {
                setAccountdata(res?.data);
            }
        } catch (err) {
            console.log(err, "err");
        }
    };
    const getcountry = async () => {
        try {
            let postdata = {};
            let res = await _Apiauth(postdata, `redis/countryList`)
            if (res?.statusCode === 200) {
                let countrydata = [];
                let phonecode = [];
                res?.data.forEach((result) => {
                    countrydata.push({
                        label: result?.name,
                        value: result?.id,
                    });
                    phonecode.push({
                        label: result?.phoneCode,
                        value: result?.phoneCode,
                    });
                });
            }
        } catch (err) {
            console.log(err, "err");
        }
    };
    useEffect(() => {
        getaccountdetails();
        getcountry();
    }, []);


    const cartData = [
        { title: "Billing & Shipping", img: billingandShippingCardImage, sub: "Manage your billing details ,shipping details", navigateto: "/account/address" },
        { title: "Appointment", img: AppointmentCardImage, sub: "View your appointment to allocate time ", navigateto: "/account/appointmentdata" },
        { title: "Purchase History", img: PurchaseHistoryCardImage, sub: "Manage your billing details ,shipping details", navigateto: "/account/purchasehistory" },
        { title: "Change Password", img: ChangePasswordCardImage, sub: "Manage your billing details ,shipping details", navigateto: "/account/changepassword" },
    ]

    return (
        <div className="bg-white d-flex">
            <Sidebar />
            <div className='account_landingpage'>
                <div className='account_landingpage-inner'>
                    {screenSize.width < 1200 ? <div className='account_landingpage-inner-title' onClick={() => navigate('/collection')}><span className='cursor-pointer'><LeftIcon /></span><span>{t("Account Details")}</span></div> : ""}
                    <div className='account_landingpage-inner-container'>
                        <div className='account_landingpage-inner-container-upper'>
                            <div className='account_landingpage-inner-container-upper-imgwrapper'>
                                <img src={accountdata?.profile ? accountdata?.profile : NoImage} alt="" />
                                {screenSize.width < 525 ? <div className='overlay'></div> : null}

                                {screenSize.width < 1200 && screenSize.width > 525 &&
                                    <div className='account_landingpage-inner-container-upper-imgwrapper-editor' onClick={() => navigate('/account/details')}>
                                        <span className='account_landingpage-inner-container-upper-imgwrapper-editor-holder'>
                                            <EditIcon />
                                        </span>
                                    </div>
                                }

                            </div>
                            <div className='account_landingpage-inner-container-upper-tagwrapper'>
                                <div className='account_landingpage-inner-container-upper-tagwrapper-title'>
                                    <span>{accountdata?.fname}</span>
                                </div>
                                {screenSize.width < 1200 ?
                                    <div className='account_landingpage-inner-container-upper-tagwrapper-default'>{t("Custom")}</div> : null
                                }
                                <div className='account_landingpage-inner-container-upper-tagwrapper-subtitle'>
                                    <span className='text'>{t("Manage your account to get ready to travel our jewelry store! ")}</span>
                                    {screenSize.width < 525 ?
                                        <div className='account_landingpage-inner-container-upper-imgwrapper-editor position-static' onClick={() => navigate('/account/details')}>
                                            <span className='account_landingpage-inner-container-upper-imgwrapper-editor-holder'>
                                                <EditIcon />
                                            </span>
                                        </div>
                                        : null}
                                </div>
                                {screenSize.width > 1200 ?
                                    <button className='btnbold roundbtn' onClick={() => navigate('/account/details')}>
                                        <span>{t("Manage")}</span>
                                    </button>
                                    : null}
                            </div>
                        </div>
                        <div className='account_landingpage-inner-container-options_card'>
                            <div className='account_landingpage-inner-container-options_card-tag'>{t("My Account")}</div>
                            <div className='account_landingpage-inner-container-options_card-wrapper'>
                                {cartData.map((item, i) => {
                                    return (
                                        <div className='account_landingpage-inner-container-options_card-wrapper-holder' key={i}>
                                            <div className='account_landingpage-inner-container-options_card-wrapper-holder-title'>{t(`${item?.title}`)}</div>
                                            <div className='account_landingpage-inner-container-options_card-wrapper-holder-image'><img src={item?.img} alt='cardimg' onClick={() => navigate(`${item?.navigateto}`)} /></div>
                                            <div className='account_landingpage-inner-container-options_card-wrapper-holder-sub'>{t(`${item?.sub}`)}</div>
                                            <button className='btnbold roundbtn' onClick={() => navigate(`${item?.navigateto}`)}>
                                                <span>{t("Manage")}</span>
                                            </button>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
